import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfigService } from '../../../tms-shared';
import { AddressLookup, AddressLookupResponse, AddressLookupSummary } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class AddressLookupService {
  baseUri = 'https://api.getAddress.io/';

  constructor(
    protected httpService: HttpClient,
    private configService: ConfigService,
  ) {}

  getAddresses(search: string): Observable<AddressLookupSummary[]> {
    return this.httpService
      .get<AddressLookupResponse>(`${this.baseUri}autocomplete/${search}${this.queryParams}`)
      .pipe(map((response: AddressLookupResponse) => response.suggestions));
  }

  getAddressDetails(url: string): Observable<AddressLookup> {
    return this.httpService.get<AddressLookup>(`${this.baseUri}${url}${this.queryParams}`);
  }

  private get queryParams() {
    return `?api-key=${this.configService.config.addressLookupApiKey}`;
  }
}
